<div class="page-container">
  <div class="flex min-w-0 flex-wrap items-center justify-between gap-2">
    <h1 class="main-heading min-w-0">
      <fa-icon [icon]="faCalculator" class="mr-2" />GST Calculation
    </h1>
    <app-navpath class="hidden md:block" />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Search</h2>
    <app-data-form
      [dataFields]="gstSearchForm"
      [dataName]="'gstSearchForm'"
      (clickSearch)="searchContract($event)"
    />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Total amounts of contract</h2>
    <app-data-form
      [dataFields]="gstTotalAmountsForm"
      [dataName]="'gstTotalAmountsForm'"
      [columns]="2"
      (updateFields_child)="updateForm($event)"
    />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Less amounts not taxable</h2>
    <app-data-form
      [dataFields]="gstLessAmountsForm"
      [dataName]="'gstLessAmountsForm'"
      [columns]="2"
      (updateFields_child)="updateForm($event)"
    />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Others (Non-GST Vehicle Only)</h2>
    <app-data-form
      [dataFields]="gstOthersForm"
      [dataName]="'gstOthersForm'"
      [columns]="2"
      (updateFields_child)="updateForm($event)"
    />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Rebates not included in GST calculation</h2>
    <app-data-form
      [dataFields]="gstRebatesForm"
      [dataName]="'gstRebatesForm'"
      [columns]="2"
    />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Others</h2>
    <app-data-form
      [dataFields]="gstFinalForm"
      [dataName]="'gstFinalForm'"
      [columns]="2"
      (updateFields_child)="updateForm($event)"
    />
  </div>
  <div class="mt-4 flex w-full flex-col gap-2 sm:flex-row sm:flex-wrap">
    <button class="shorter-btn misc-btn" (click)="saveRecord()">
        <fa-icon [icon]="faSave" class="mr-1" />Save
    </button>
    <button class="shorter-btn misc-btn" (click)="printRecord()">
        <fa-icon [icon]="faPrint" class="mr-1" />Print
    </button>
    <button class="shorter-btn misc-btn" (click)="toInvoice()">
        <fa-icon [icon]="faChain" class="mr-1" />To Invoice
    </button>
</div>

<div
  *ngIf="showSaveConfirmation"
  class="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 p-4"
  (click)="cancelSaveConfirmation()"
>
  <section
    role="dialog"
    aria-modal="true"
    aria-labelledby="gst-save-confirm-title"
    class="w-full max-w-[46.875rem] bg-white text-[#444] shadow-xl"
    (click)="$event.stopPropagation()"
  >
    <header class="flex items-center justify-between border-b border-gray-200 px-5 py-4">
      <h2 id="gst-save-confirm-title" class="m-0 text-base font-normal">Please Confirm</h2>
      <button
        type="button"
        class="text-2xl leading-none text-[#4b77b8] hover:text-[#315b96]"
        aria-label="Close confirmation"
        (click)="cancelSaveConfirmation()"
      >
        &times;
      </button>
    </header>
    <div class="px-5 py-5 text-sm leading-6">
      This contract is already invoiced. Are you sure to continue?
    </div>
    <footer class="flex justify-end gap-2 border-t border-gray-200 px-5 py-4">
      <button
        type="button"
        class="bg-[#f5f5f5] px-4 py-2 text-sm text-[#777] hover:bg-gray-200"
        (click)="cancelSaveConfirmation()"
      >
        No
      </button>
      <button
        type="button"
        class="bg-[#00a65a] px-4 py-2 text-sm text-white hover:bg-[#008d4c]"
        (click)="confirmSaveRecord()"
      >
        Yes
      </button>
    </footer>
  </section>
</div>
</div>
